import React, { FC, useMemo } from "react";
import { tombac, Text, Button, Box, useToasts } from "tombac";
import { CopyIcon } from "tombac-icons";
import { UserProductSafe } from "./../legolandApi/legolandApiTypes";
import { renderProductIcon } from "../../icons";

export type ProductsApiKeysProps = {
  products: UserProductSafe[] | undefined;
};

export const ProductsApiKeys: FC<ProductsApiKeysProps> = ({ products }) => {
  const { addToast } = useToasts();

  const handleCopyClick = async (apiKey: string) => {
    try {
      await navigator.clipboard.writeText(apiKey);
      addToast("The API key is copied to the clipboard", "success");
    } catch (e) {
      addToast("Failed to copy the API key to the clipboard", "danger");
    }
  };

  const productsByApiKey = useMemo(() => {
    return products?.reduce((acc, item) => {
      if (item.access.status !== "GRANTED") return acc;
      const key = item.access.apiKey;
      if (!key) return acc;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as Record<string, UserProductSafe[]>);
  }, [products]);

  if (!productsByApiKey) return [];

  return Object.entries(productsByApiKey).map((product) => {
    const [key, products] = product;
    const productsElement = products.map((p) => (
      <span> {renderProductIcon(p.id)}</span>
    ));

    return (
      <Box
        $paddingBottom="2sp"
        $marginBottom="2sp"
        $borderBottom={`1px solid ${tombac.color("neutral", 300)}`}
      >
        <Box>{productsElement}</Box>
        <Text $pt="0.5sp" $display="inline-block">
          {key}
        </Text>
        <Button
          onClick={() => handleCopyClick(key)}
          shape="circle"
          size="xs"
          variant="flat"
        >
          <CopyIcon />
        </Button>
      </Box>
    );
  });
};
